module.exports = __webpack_public_path__ + "static/media/20th_anniversary.cd9c8f24.jpg";